import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireResourceManagerFrontend } from "/Users/rbass4/Code/elon-cms/u/wp-content/plugins/elonu-plugin-resource-manager/assets/js/src/resource-manager-frontend.js";
var resourceManagerFrontendExports = requireResourceManagerFrontend();
export { resourceManagerFrontendExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(resourceManagerFrontendExports);